<template>
    <div
        v-click-outside="closeDropdown"
        class="nav-box mb-6"
        :class="{'cursor-pointer': hasSingleProduct}"
        @click="handleCategoryClick">
        <!--Category Title-->
        <h3
            class="bg-black-700 opacity-75 text-xs font-bold uppercase text-gray-500 py-1 px-4 tracking-wider phone:text-sm border-b border-gray-500 transition-all"
            :class="{'text-gold-500 border-gold-500': isActiveDropdown}"
        >
            {{ categoryLabel }}
        </h3>

        <!--Dropdown Mode Active Item-->
        <div
            class="slider-nav-more desktop:hidden uppercase text-sm text-gray-500 tracking-widest bg-black-700 px-4 pt-3 pb-2 border-t opacity-75 border-gray-500 transition-all cursor-pointer flex justify-between"
            :class="{'hidden': showAll, 'text-white border-t-2 border-gold-500': isActiveDropdown}"
            @click="showAll=true"
        >
            {{ dropdownLabel }}
            <svg-icon
                icon="chevron"
                class="transform rotate-90 w-6 h-4 inline-block text-gold-500" />
        </div>

        <!--Service Items Iterator-->
        <div
            class="flex flex-col desktop:block"
            :class="{'phone:hidden tablet:hidden tabletLandscape:hidden': !showAll}">
            <div
                v-for="(product, index) in products"
                :key="index"
                class="bg-black-700 p-2 text-sm font-regular uppercase tracking-widest opacity-75 border-t border-gray-500 transition-all cursor-pointer phone:text-sm desktop:p-3 hd:p-4"
                :class="{
                    'text-white border-t-2 border-gold-500': product.productId === currentProductSlug && isActiveDropdown,
                    'text-gray-500': product.productId !== currentProductSlug || !isActiveDropdown}"
                @click="handleProductChange(product)"
            >
                <span class="block">{{ product.productControl.productGalleryItem }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import vClickOutside from 'v-click-outside';
import get from 'lodash/get';

export default {
  name: 'ProductControls',
  components: {
    SvgIcon,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    categoryLabel: {
      type: String,
      required: true,
    },
    categorySlug: {
      type: String,
      required: true,
    },
    currentProductSlug: {
      type: String,
      required: true,
    },
    products: {
      type: Object,
      required: true,
    },
    onProductChange: {
      type: Function,
      required: true,
    },
    // allows for multiple dropdown situations
    // then you can specify if this dropdown is "active" or not
    // by default it is
    isActiveDropdown: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    showAll: false,
  }),
  computed: {
    dropdownLabel() {
      // in multiple dropdown scenarios, this.currentSlide may be undefined if currentSlide > # of slide for an inactive dropdown.
      // For inactive dropdowns, reset the label to the first item in the list.
      if (this.isActiveDropdown) {
        return get(this.products, [this.currentProductSlug, 'productControl', 'productGalleryItem']);
      }

      return get(this.products, [Object.keys(this.products)[0], 'productControl', 'productGalleryItem']);
    },
    hasSingleProduct() {
      return Object.keys(this.products).length === 1;
    },
  },
  methods: {
    handleCategoryClick() {
      if (!this.hasSingleProduct) {
        return;
      }

      this.closeDropdown();
      this.onProductChange(get(this.products, [Object.keys(this.products)[0], 'productId']), this.categorySlug);
    },
    handleProductChange(product) {
      this.closeDropdown();
      this.onProductChange(product.productId, this.categorySlug);
    },
    closeDropdown() {
      this.showAll = false;
    },
  },
};
</script>

<style scoped>
    .nav-box {
        width: 240px;
    }
    .slider-nav-more {
        min-height: 56px;
    }
</style>
